export default "__VITE_ASSET__uj4pDopE__"